
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2Ynul", function(module, exports) {
$parcel$export(module.exports, "ConnectIframe", () => (parcelRequire("6cv0h")).ConnectIframe);
$parcel$export(module.exports, "FlagModule", () => (parcelRequire("kqt5Y")).FlagModule);
$parcel$export(module.exports, "MessageModule", () => (parcelRequire("4G3kC")).MessageModule);
/* eslint-disable */ // @ts-nocheck

var $iPYNj = parcelRequire("iPYNj");


var $6cKPu = parcelRequire("6cKPu");


var $ZdCQL = parcelRequire("ZdCQL");


var $hIXlJ = parcelRequire("hIXlJ");


var $6cv0h = parcelRequire("6cv0h");


var $kqt5Y = parcelRequire("kqt5Y");


var $2yxK1 = parcelRequire("2yxK1");


var $jITTC = parcelRequire("jITTC");


var $9MaFN = parcelRequire("9MaFN");


var $9kO8O = parcelRequire("9kO8O");


var $4G3kC = parcelRequire("4G3kC");


var $4AyEX = parcelRequire("4AyEX");


var $awwWq = parcelRequire("awwWq");


var $e2rLA = parcelRequire("e2rLA");


var $i2nif = parcelRequire("i2nif");


var $k9hyL = parcelRequire("k9hyL");


var $iViFj = parcelRequire("iViFj");


var $jEqev = parcelRequire("jEqev");


var $g7tdI = parcelRequire("g7tdI");


});

parcelRegister("iPYNj", function(module, exports) {
/* eslint-disable */ // @ts-nocheck
/* eslint-disable */ class $3404b07fee6ae0f2$var$DefaultAnalyticsAPI {
    trigger(category, action, payload) {
    // Do nothing.
    }
    markAsSafe(...allowedStrings) {
        // Do no filtering
        return (value)=>{
            return value;
        };
    }
    dangerouslyCreateSafeString(value) {
        // Do nothing
        return value;
    }
}
var $3404b07fee6ae0f2$export$2e2bcd8739ae039 = new $3404b07fee6ae0f2$var$DefaultAnalyticsAPI();



var $4AyEX = parcelRequire("4AyEX");

class $43a41e37f5c492d0$var$AnalyticsController {
    isLoggingEnabled() {
        return this.loggingEnabled;
    }
    constructor(){
        this.loggingEnabled = false;
    }
}
/**
 * This class serves two purposes:
 *   - It provides the ability for products to register their implementations
 *     of AnalyticsAPI for use by the connect front end code.
 *   - It provides the AnalyticsAPI implementation that connect front end code
 *     should use. This implementation delegates to the registered AnalyticsAPI
 *     implementation. This class should be used within the connect front end
 *     code as follows:
 *
 *     import analytics from '../adaptors/analytics/AnalyticsAdaptor';
 *
 *     analytics.trigger('Flags', 'close', {'type': 'warning'});
 */ class $43a41e37f5c492d0$var$AnalyticsAdaptor {
    /**
   * Implementation of AnalyticsRegistry#registerAnalyticsAPI().
   */ registerAnalyticsAPI(analyticsAPI) {
        this.analyticsAPI = analyticsAPI;
    }
    /**
   * Implementation of AnalyticsAPI#trigger() for use by connect-module-core code.
   */ trigger(category, action, appKey, payload) {
        try {
            this.analyticsAPI.trigger(category, action, appKey, payload);
            if (this.analyticsController.isLoggingEnabled()) (0, $4AyEX.logger).info('Analytics:', category, action, appKey, payload);
        } catch (exception) {
            (0, $4AyEX.logger).warn('Exception trapped triggering analytics event', exception);
        }
    }
    markAsSafe(...allowedStrings) {
        if (this.analyticsAPI.markAsSafe) return this.analyticsAPI.markAsSafe(...allowedStrings);
        else return (0, $3404b07fee6ae0f2$export$2e2bcd8739ae039).markAsSafe(...allowedStrings);
    }
    dangerouslyCreateSafeString(value) {
        if (this.analyticsAPI.dangerouslyCreateSafeString) return this.analyticsAPI.dangerouslyCreateSafeString(value);
        else return (0, $3404b07fee6ae0f2$export$2e2bcd8739ae039).dangerouslyCreateSafeString(value);
    }
    constructor(){
        this.analyticsController = void 0;
        this.analyticsAPI = (0, $3404b07fee6ae0f2$export$2e2bcd8739ae039);
        this.analyticsController = new $43a41e37f5c492d0$var$AnalyticsController();
        window._analyticsController = this.analyticsController;
    }
}
const $43a41e37f5c492d0$export$71a493436f9bccb6 = new $43a41e37f5c492d0$var$AnalyticsAdaptor();
module.exports["analytics"] = $43a41e37f5c492d0$export$71a493436f9bccb6;

});

parcelRegister("6cKPu", function(module, exports) {
/* eslint-disable */ // @ts-nocheck

var $ZdCQL = parcelRequire("ZdCQL");

/**
 * This class provides the Adaptor implementation for ACJS
 */ class $6e1b1e62f6f32af5$var$ACJSFrameworkAdaptor extends (0, $ZdCQL.BaseFrameworkAdaptor) {
    registerModuleWithHost(moduleName, simpleXdmDefinition) {
    // Do nothing - ACJS is already registering all core modules.
    }
    getProviderByModuleName(moduleName) {
        return super.getProviderByModuleName(moduleName);
    }
}
const $6e1b1e62f6f32af5$export$8782e9f160c2e1e7 = new $6e1b1e62f6f32af5$var$ACJSFrameworkAdaptor();

});

parcelRegister("ZdCQL", function(module, exports) {
/* eslint-disable */ // @ts-nocheck
class $260850f22311da41$export$4944e39ef1fb1533 {
    /**
   * This method registers a module with the Connect client framework relating to this adaptor instance.
   * @param moduleDefinition the definition of the module.
   */ registerModule(module, props) {
        const moduleRegistrationName = module.getModuleRegistrationName();
        this.moduleNamesToModules.set(moduleRegistrationName, module);
        const simpleXdmDefinitionBuilder = module.getSimpleXdmDefinitionBuilder();
        const simpleXdmDefinition = simpleXdmDefinitionBuilder.buildSimpleXdmDefinition();
        this.registerModuleWithHost(moduleRegistrationName, simpleXdmDefinition);
    }
    getModuleByName(moduleName) {
        return this.moduleNamesToModules.get(moduleName);
    }
    /**
   * This routine gets a module provider based on the module's name. The provider will only be returned if
   * the module is enabled.
   * @param moduleName the name of the module.
   * @returns {any} the module provider if found and enabled.
   */ getProviderByModuleName(moduleName) {
        const module = this.moduleNamesToModules.get(moduleName);
        if (module && module.isEnabled()) return module.getProvider();
        else return undefined;
    }
    constructor(){
        this.moduleNamesToModules = new Map();
    }
}
module.exports["BaseFrameworkAdaptor"] = $260850f22311da41$export$4944e39ef1fb1533;

});

parcelRegister("hIXlJ", function(module, exports) {
/* eslint-disable */ // @ts-nocheck

var $ZdCQL = parcelRequire("ZdCQL");

/**
 * This class provides the Connect client framework adaptor implementation for CaaS.
 */ class $d5a0e15214f3dee6$var$CaaSFrameworkAdaptor extends (0, $ZdCQL.BaseFrameworkAdaptor) {
    registerModuleWithHost(moduleName, simpleXdmDefinition) {
    // Removing the dependency on connect-client to ensure we don't bloat out the size of
    // the code unnecessarily. The following line will be re-instated during the migration
    // to CaaS.
    //defineModule(moduleName, simpleXdmDefinition);
    }
}
const $d5a0e15214f3dee6$export$6fe9107a24d38c8 = new $d5a0e15214f3dee6$var$CaaSFrameworkAdaptor();

});

parcelRegister("6cv0h", function(module, exports) {
/* eslint-disable */ // @ts-nocheck

var $42omo = parcelRequire("42omo");


var $4AyEX = parcelRequire("4AyEX");


var $iPYNj = parcelRequire("iPYNj");

/* eslint-disable */ // @ts-nocheck







var $8tdEV = parcelRequire("8tdEV");

/*
 * Same as in ACJS. See loading_indicator.js.
 */ const $933fed589a0966ac$var$DEFAULT_APP_LOADING_TIMEOUT = 12000;
let $933fed589a0966ac$var$connectIframes = [];
let $933fed589a0966ac$var$registerHostCallbacks = true;
const $933fed589a0966ac$var$hostIframeEstablishedCallback = (data)=>{
    const connectIframe = $933fed589a0966ac$var$connectIframes.find((connectIframe)=>data.extension.id === connectIframe.getId());
    if (connectIframe) {
        const manager = connectIframe.getIFrameLifecycleEventManager();
        if (manager) manager.iframeEstablishedCallback(data);
    }
};
const $933fed589a0966ac$var$hostIframeUnloadCallback = (data)=>{
    const connectIframe = $933fed589a0966ac$var$connectIframes.find((connectIframe)=>data.extension.id === connectIframe.getId());
    if (connectIframe) {
        const manager = connectIframe.getIFrameLifecycleEventManager();
        if (manager) manager.iframeUnloadCallback(data);
    }
};
class $933fed589a0966ac$export$2e2bcd8739ae039 {
    constructor(_connectIframe){
        this.timeoutHandle = void 0;
        this.creationTimeMs = void 0;
        this.connectIframe = void 0;
        this.iframeEstablishedCallbacks = void 0;
        this.reset = ()=>{
            $933fed589a0966ac$var$connectIframes = [];
            $933fed589a0966ac$var$registerHostCallbacks = true;
        };
        this.unregister = (connectIframe)=>{
            var index = $933fed589a0966ac$var$connectIframes.indexOf(connectIframe);
            if (index > -1) $933fed589a0966ac$var$connectIframes.splice(index, 1);
            this.clearTimeoutDetectionProcessing();
        };
        this.iframeEstablishedCallback = (data)=>{
            (0, $4AyEX.logger).debug('Established iframe for add-on ', data.extension.addon_key, data);
            if (this.connectIframe.props.connectIframeProvider.handleIframeLoadingComplete) this.connectIframe.props.connectIframeProvider.handleIframeLoadingComplete(data.extension.addon_key);
            const loadTime = new Date().getTime();
            const durationToLoadMs = loadTime - this.creationTimeMs;
            const payload = {
                hostFrameOffset: (0, $iPYNj.analytics).dangerouslyCreateSafeString((this.connectIframe.props.options.hostFrameOffset || 1).toString()),
                durationToLoadMs: (0, $iPYNj.analytics).dangerouslyCreateSafeString(durationToLoadMs.toString())
            };
            (0, $iPYNj.analytics).trigger((0, $8tdEV.AnalyticsCategories).iframe, (0, $iPYNj.analytics).markAsSafe(...(0, $8tdEV.allowedStrings))((0, $8tdEV.AnalyticsActions).established), (0, $iPYNj.analytics).dangerouslyCreateSafeString(data.extension.addon_key), payload);
            this.connectIframe.iframeEstablishedCallback();
            this.clearTimeoutDetectionProcessing();
        };
        this.iframeUnloadCallback = (data)=>{
            (0, $4AyEX.logger).debug('Unloaded iframe for add-on ', data.extension.id, data);
            if (this.connectIframe.props.connectIframeProvider.handleIframeUnload) this.connectIframe.props.connectIframeProvider.handleIframeUnload(data.extension.id);
            const unloadTime = new Date().getTime();
            const sessionDurationMs = unloadTime - this.creationTimeMs;
            const payload = {
                hostFrameOffset: (0, $iPYNj.analytics).dangerouslyCreateSafeString((this.connectIframe.props.options.hostFrameOffset || 1).toString()),
                sessionDurationMs: (0, $iPYNj.analytics).dangerouslyCreateSafeString(sessionDurationMs.toString())
            };
            (0, $iPYNj.analytics).trigger((0, $8tdEV.AnalyticsCategories).iframe, (0, $iPYNj.analytics).markAsSafe(...(0, $8tdEV.allowedStrings))((0, $8tdEV.AnalyticsActions).close), (0, $iPYNj.analytics).dangerouslyCreateSafeString(data.extension.id), payload);
        };
        this.startTimeoutDetectionProcessing = ()=>{
            (0, $4AyEX.logger).debug('Starting iframe timed out processing for add-on ', this.connectIframe.props.appKey);
            const timeoutMilliseconds = this.getLoadingTimeout();
            this.timeoutHandle = window.setTimeout(()=>{
                (0, $4AyEX.logger).warn('Add-on iframe timed out for add-on ', this.connectIframe.props.appKey);
                this.timeoutHandle = 0;
                if (this.connectIframe.props.connectIframeProvider.handleIframeLoadTimeout) this.connectIframe.props.connectIframeProvider.handleIframeLoadTimeout(this.connectIframe.props.appKey, this.connectIframe.iframeFailedToLoadCallback.bind(this));
                const payload = {
                    hostFrameOffset: (0, $iPYNj.analytics).dangerouslyCreateSafeString((this.connectIframe.props.options.hostFrameOffset || 1).toString())
                };
                (0, $iPYNj.analytics).trigger((0, $8tdEV.AnalyticsCategories).iframe, (0, $iPYNj.analytics).markAsSafe(...(0, $8tdEV.allowedStrings))((0, $8tdEV.AnalyticsActions).timeout), (0, $iPYNj.analytics).dangerouslyCreateSafeString(this.connectIframe.props.appKey), payload);
                this.connectIframe.iframeTimeoutCallback();
            }, timeoutMilliseconds);
        };
        this.getLoadingTimeout = ()=>{
            const providedTimeoutMilliseconds = this.connectIframe.props.connectIframeProvider.getLoadingTimeoutMilliseconds ? this.connectIframe.props.connectIframeProvider.getLoadingTimeoutMilliseconds(this.connectIframe.props.appKey) : $933fed589a0966ac$var$DEFAULT_APP_LOADING_TIMEOUT;
            const timeoutMilliseconds = providedTimeoutMilliseconds && providedTimeoutMilliseconds > 0 ? providedTimeoutMilliseconds : $933fed589a0966ac$var$DEFAULT_APP_LOADING_TIMEOUT;
            return timeoutMilliseconds;
        };
        this.clearTimeoutDetectionProcessing = ()=>{
            if (this.timeoutHandle) {
                (0, $4AyEX.logger).debug('Clearing iframe timed out timer for add-on ', this.connectIframe.props.appKey);
                window.clearTimeout(this.timeoutHandle);
                this.timeoutHandle = 0;
            }
        };
        this.creationTimeMs = new Date().getTime();
        this.connectIframe = _connectIframe;
        $933fed589a0966ac$var$connectIframes.push(_connectIframe);
        if ($933fed589a0966ac$var$registerHostCallbacks) {
            this.connectIframe.props.connectHost.onIframeEstablished($933fed589a0966ac$var$hostIframeEstablishedCallback);
            this.connectIframe.props.connectHost.onIframeUnload($933fed589a0966ac$var$hostIframeUnloadCallback);
            $933fed589a0966ac$var$registerHostCallbacks = false;
        }
        this.startTimeoutDetectionProcessing();
        if (this.connectIframe.props.connectIframeProvider.handleIframeLoadingStarted) this.connectIframe.props.connectIframeProvider.handleIframeLoadingStarted(this.connectIframe.props.appKey);
    }
}





const $d310c22525aab119$export$62aa48085237e36f = Object.freeze({
    INIT: Symbol('init'),
    LOADED: Symbol('loaded'),
    FAILED: Symbol('failed'),
    TIMEOUT: Symbol('timeout'),
    LOADING: Symbol('loading'),
    RESOLVING: Symbol('resolving')
});
/**
 * ConnectIframe represents an add-on within a view.
 *
 * Important: Many iframe props, such as URL and options (context) cannot be changed after the iframe has been initialized.
 * This is because these props are passed to the iframe upon initial creation.
 * If you wish to change these properties, you must force the React component to be destroyed and recreated.
 * The easiest way to do this is by using React's "key" prop to create a new instance of the component.
 */ class $d310c22525aab119$export$8968565585c2471b extends $42omo.PureComponent {
    componentWillReceiveProps(nextProps) {
        if (this.props.appKey !== nextProps.appKey || this.props.moduleKey !== nextProps.moduleKey) {
            this._unregisterIFrameLifecycleManager();
            this._destroyExtension();
            this.setState({
                width: nextProps.width,
                height: nextProps.height,
                hostFrameOffset: nextProps.options.hostFrameOffset || 1,
                loadingState: $d310c22525aab119$export$62aa48085237e36f.INIT
            });
            this.iframeContext = {
                url: nextProps.url,
                appKey: nextProps.appKey,
                moduleKey: nextProps.moduleKey,
                options: nextProps.options
            };
        }
    }
    componentWillUnmount() {
        this.unmountCallbacks.forEach((cb)=>cb());
        this._unregisterIFrameLifecycleManager();
        this._destroyExtension();
    }
    render() {
        switch(this.state.loadingState){
            case $d310c22525aab119$export$62aa48085237e36f.LOADED:
            case $d310c22525aab119$export$62aa48085237e36f.LOADING:
            case $d310c22525aab119$export$62aa48085237e36f.TIMEOUT:
                let iframeStyles;
                // Ask the product for the styles to use...
                if (this.props.connectIframeProvider.buildIframeStyles) iframeStyles = this.props.connectIframeProvider.buildIframeStyles(this.state.loadingState, $d310c22525aab119$export$62aa48085237e36f);
                // if iframeStyles is undefined and loadingState is loading/timeout, set the default style
                if (!iframeStyles && (this.state.loadingState === $d310c22525aab119$export$62aa48085237e36f.LOADING || this.state.loadingState === $d310c22525aab119$export$62aa48085237e36f.TIMEOUT)) iframeStyles = {
                    opacity: 0.0
                };
                return /*#__PURE__*/ $42omo.createElement(this.props.iframeContainer, {
                    width: this.state.width,
                    height: this.state.height
                }, this.state.loadingState === $d310c22525aab119$export$62aa48085237e36f.TIMEOUT ? /*#__PURE__*/ $42omo.createElement(this.props.timeoutIndicator, {
                    failedCallback: this.iframeFailedToLoadCallback.bind(this)
                }) : null, this.state.loadingState === $d310c22525aab119$export$62aa48085237e36f.LOADING ? /*#__PURE__*/ $42omo.createElement(this.props.loadingIndicator, null) : null, this._isSubIframe() ? this.props.children : /*#__PURE__*/ $42omo.createElement("iframe", {
                    "data-testid": "connect-iframe",
                    frameBorder: "0",
                    width: this.state.width,
                    height: this.state.height,
                    style: {
                        display: 'block',
                        ...iframeStyles
                    },
                    ...this.iframeAttributes,
                    "aria-label": this.props.options.title,
                    referrerPolicy: 'no-referrer'
                }, this.props.children));
            case $d310c22525aab119$export$62aa48085237e36f.FAILED:
                return /*#__PURE__*/ $42omo.createElement("div", {
                    style: {
                        height: this.state.height
                    }
                }, /*#__PURE__*/ $42omo.createElement(this.props.failedToLoadIndicator, null));
            case $d310c22525aab119$export$62aa48085237e36f.INIT:
            case $d310c22525aab119$export$62aa48085237e36f.RESOLVING:
            default:
                return null;
        }
    }
    componentDidMount() {
        if (this.state.loadingState === $d310c22525aab119$export$62aa48085237e36f.INIT) {
            this.setState({
                loadingState: $d310c22525aab119$export$62aa48085237e36f.RESOLVING
            });
            this._initialise();
        }
    }
    componentDidUpdate() {
        if (this.state.loadingState === $d310c22525aab119$export$62aa48085237e36f.INIT) {
            this.setState({
                loadingState: $d310c22525aab119$export$62aa48085237e36f.RESOLVING
            });
            this._initialise();
        }
    }
    constructor(props){
        super(props);
        this.unmountCallbacks = [];
        this.iframeContext = void 0;
        this.iframeAttributes = void 0;
        this.iframeLifecycleEventManager = void 0;
        this.resize = (width, height)=>{
            this.setState({
                width: width,
                height: height
            });
        };
        this.sizeToParent = ()=>{
            this.setState({
                width: '100%',
                height: '100%'
            });
        };
        this.registerUnmountCallback = (callback)=>{
            this.unmountCallbacks.push(callback);
        };
        this.hideInlineDialog = ()=>{
            if (this.props.connectIframeProvider.onHideInlineDialog) this.props.connectIframeProvider.onHideInlineDialog();
        };
        this.getId = ()=>{
            if (this.iframeAttributes) return this.iframeAttributes.id;
            else return null;
        };
        this.getIFrameLifecycleEventManager = ()=>{
            return this.iframeLifecycleEventManager;
        };
        this.iframeEstablishedCallback = ()=>{
            this.setState({
                loadingState: $d310c22525aab119$export$62aa48085237e36f.LOADED
            });
        };
        this.iframeFailedToLoadCallback = ()=>{
            this.setState({
                loadingState: $d310c22525aab119$export$62aa48085237e36f.FAILED
            });
        };
        this.iframeTimeoutCallback = ()=>{
            this.setState({
                loadingState: $d310c22525aab119$export$62aa48085237e36f.TIMEOUT
            });
        };
        this._createIFrameLifecycleManager = ()=>{
            this.iframeLifecycleEventManager = new (0, $933fed589a0966ac$export$2e2bcd8739ae039)(this);
        };
        this._unregisterIFrameLifecycleManager = ()=>{
            if (this.iframeLifecycleEventManager) this.iframeLifecycleEventManager.unregister(this);
        };
        this._createExtension = ()=>{
            const simpleXdmExtension = this.props.connectHost.createExtension({
                addon_key: this.iframeContext.appKey,
                key: this.iframeContext.moduleKey,
                url: this.iframeContext.url,
                options: Object.assign({
                    hostFrameOffset: 1
                }, this.iframeContext.options, {
                    resize: this.resize.bind(this),
                    sizeToParent: this.sizeToParent.bind(this),
                    registerUnmountCallback: this.registerUnmountCallback.bind(this),
                    _contextualOperations: {
                        hideInlineDialog: this.hideInlineDialog.bind(this)
                    }
                })
            });
            this.iframeAttributes = simpleXdmExtension.iframeAttributes;
            (0, $4AyEX.logger).debug('Created iframe for add-on ', this.iframeContext.appKey, this.iframeAttributes);
            (0, $iPYNj.analytics).trigger((0, $8tdEV.AnalyticsCategories).iframe, (0, $iPYNj.analytics).markAsSafe(...(0, $8tdEV.allowedStrings))((0, $8tdEV.AnalyticsActions).create), (0, $iPYNj.analytics).dangerouslyCreateSafeString(this.iframeContext.appKey), {});
        };
        this._destroyExtension = ()=>{
            if (this.iframeAttributes) this.props.connectHost.destroy(this.iframeAttributes.id);
        };
        this._isSubIframe = ()=>{
            return this.state.hostFrameOffset && this.state.hostFrameOffset > 1;
        };
        this._initialise = ()=>{
            if (this.props.children && this.props.connectIframeProvider.onStoreNestedIframeJSON) {
                const childComponent = this.props.children;
                const childProps = childComponent.props;
                this.props.connectIframeProvider.onStoreNestedIframeJSON(childProps);
            }
            if (this._isSubIframe()) {
                this.setState({
                    loadingState: $d310c22525aab119$export$62aa48085237e36f.LOADING
                });
                return;
            }
            this._createIFrameLifecycleManager();
            if (!this.props.connectIframeProvider.resolveIframeContext) {
                this._createExtension();
                this.setState({
                    loadingState: $d310c22525aab119$export$62aa48085237e36f.LOADING
                });
                return;
            }
            this.props.connectIframeProvider.resolveIframeContext(this.iframeContext, this.props.connectHost).then((iframeContext)=>{
                const propsMutated = iframeContext.appKey !== this.props.appKey || iframeContext.moduleKey !== this.props.moduleKey;
                if (propsMutated) {
                    (0, $4AyEX.logger).warn('Iframe context changed during resolution');
                    return;
                }
                this.iframeContext = iframeContext;
                this._createExtension();
                this.setState({
                    loadingState: $d310c22525aab119$export$62aa48085237e36f.LOADING
                });
            });
        };
        this.state = {
            width: props.width,
            height: props.height,
            loadingState: $d310c22525aab119$export$62aa48085237e36f.INIT,
            hostFrameOffset: props.options.hostFrameOffset || 1
        };
        this.iframeContext = {
            url: props.url,
            appKey: props.appKey,
            moduleKey: props.moduleKey,
            options: props.options
        };
    }
}
$d310c22525aab119$export$8968565585c2471b.defaultProps = {
    options: {},
    connectIframeProvider: {},
    iframeContainer: ({ width: width, height: height, children: children })=>/*#__PURE__*/ $42omo.createElement("div", {
            "data-testid": "iframe-container",
            style: {
                position: 'relative',
                width: width === '100%' ? '100%' : 'auto',
                height: height === '100%' ? '100%' : 'auto'
            }
        }, children),
    failedToLoadIndicator: ()=>null,
    loadingIndicator: ()=>null,
    timeoutIndicator: ()=>null
};
module.exports["ConnectIframe"] = $d310c22525aab119$export$8968565585c2471b;

});

parcelRegister("kqt5Y", function(module, exports) {
/* eslint-disable */ // @ts-nocheck

var $awwWq = parcelRequire("awwWq");

/* eslint-disable */ // @ts-nocheck
class $31c03035c886726b$export$94f22dab2f68a598 {
    buildSimpleXdmDefinition() {
        var flagProvider = this.flagProvider;
        /*
     * This class is a proxy to the flag object created by the flag provider. It is
     * equivalent to the Flag class defined in atlassian-connect-js/src/modules/flag.js
     * except that it does not pull in any AUI flag implementation.
     */ class FlagProxy {
            close() {
                this.flag.close();
            }
            constructor(options, callback){
                this.flag = void 0;
                options.id = callback._id;
                const flagId = callback._id;
                let actions = [];
                if (typeof options.actions === 'object') actions = Object.getOwnPropertyNames(options.actions).map((key)=>{
                    return {
                        actionKey: key,
                        actionText: options.actions[key],
                        executeAction: ()=>{
                            console.log('This needs to be implemented by broadcasting a "flag-action-invoked" event.');
                        }
                    };
                });
                const flagOptions = {
                    id: flagId,
                    title: options.title,
                    body: options.body,
                    actions: actions,
                    onClose: ()=>{
                        console.log('This needs to be implemented by broadcasting a "flag.close" event.');
                    },
                    close: options.close,
                    type: options.type.toLowerCase()
                };
                this.flag = flagProvider.create(flagOptions);
            }
        }
        return {
            create: {
                constructor: FlagProxy,
                close: FlagProxy.prototype.close
            }
        };
    }
    constructor(flagProvider){
        this.flagProvider = void 0;
        if (!flagProvider) throw new Error('flagProvider is not defined');
        this.flagProvider = flagProvider;
    }
}


(function(FlagModuleDefinitions) {
    FlagModuleDefinitions.FLAG_MODULE_NAME = 'flag';
    class Props {
        constructor(adaptor, flagProvider){
            this.adaptor = void 0;
            this.flagProvider = void 0;
            this.adaptor = adaptor;
            this.flagProvider = flagProvider;
        }
    }
    FlagModuleDefinitions.Props = Props;
    class State {
        constructor(flagProvider){
            this.enabled = void 0;
            this.registered = void 0;
            this.flagProvider = void 0;
            this.simpleXdmDefinitionBuilder = void 0;
            this.enabled = true;
            this.registered = false;
            this.flagProvider = flagProvider;
            this.simpleXdmDefinitionBuilder = new (0, $31c03035c886726b$export$94f22dab2f68a598)(flagProvider);
        }
    }
    FlagModuleDefinitions.State = State;
})($853a61a50cd52a71$export$748372235e8d793 || ($853a61a50cd52a71$export$748372235e8d793 = {}));
class $853a61a50cd52a71$export$7031eb52127e17da extends (0, $awwWq.BaseModule) {
    componentWillMount() {
        if (!this.props.flagProvider) throw new Error('this.props.flagProvider is not defined');
        this.setState(new $853a61a50cd52a71$export$748372235e8d793.State(this.props.flagProvider));
    }
    getModuleRegistrationName() {
        return $853a61a50cd52a71$export$748372235e8d793.FLAG_MODULE_NAME;
    }
    getSimpleXdmDefinitionBuilder() {
        return this.state.simpleXdmDefinitionBuilder;
    }
    getProvider() {
        return this.props.flagProvider;
    }
    render() {
        return null;
    }
    constructor(props){
        super(props);
    }
}
var $853a61a50cd52a71$export$748372235e8d793;
module.exports["FlagModule"] = $853a61a50cd52a71$export$7031eb52127e17da;

});

parcelRegister("2yxK1", function(module, exports) {
/* eslint-disable */ // @ts-nocheck

var $iPYNj = parcelRequire("iPYNj");


var $8tdEV = parcelRequire("8tdEV");


var $4AyEX = parcelRequire("4AyEX");

/**
 * This is the default way that products should use to implement InlineDialogProvider operations.
 */ class $9f1c1d9a183d4acf$export$42f4559178b41306 {
    hide(appContext) {
        const appHasHideOperation = appContext.extension.options._contextualOperations && appContext.extension.options._contextualOperations.hideInlineDialog && typeof appContext.extension.options._contextualOperations.hideInlineDialog === 'function';
        if (appHasHideOperation) {
            appContext.extension.options._contextualOperations.hideInlineDialog();
            (0, $4AyEX.logger).debug('Hiding inline dialog...');
            (0, $iPYNj.analytics).trigger((0, $8tdEV.AnalyticsCategories).inlineDialog, (0, $8tdEV.AnalyticsActions).close, appContext.extension.addon_key, {});
        } else {
            (0, $4AyEX.logger).warn('Attempted to hide the inline dialog for a malformed app: ', appContext);
            (0, $iPYNj.analytics).trigger((0, $8tdEV.AnalyticsCategories).inlineDialog, (0, $8tdEV.AnalyticsActions).error, appContext.extension.addon_key, {
                message: 'No hideInlineDialog function'
            });
        }
    }
}

});

parcelRegister("jITTC", function(module, exports) {
/* eslint-disable */ // @ts-nocheck

var $awwWq = parcelRequire("awwWq");

/* eslint-disable */ // @ts-nocheck
class $2383109b91961b3d$export$b85c05da5be2a57c {
    buildSimpleXdmDefinition() {
        return {
        };
    }
    constructor(dialogProvider){
        this.dialogProvider = void 0;
        if (!dialogProvider) throw new Error('dialogProvider is not defined');
        this.dialogProvider = dialogProvider;
    }
}


(function(DialogModuleDefinitions) {
    DialogModuleDefinitions.DIALOG_MODULE_NAME = 'dialog';
    class Props {
        constructor(adaptor, dialogProvider){
            this.adaptor = void 0;
            this.dialogProvider = void 0;
            this.adaptor = adaptor;
            this.dialogProvider = dialogProvider;
        }
    }
    DialogModuleDefinitions.Props = Props;
    class State {
        constructor(dialogProvider){
            this.enabled = void 0;
            this.registered = void 0;
            this.dialogProvider = void 0;
            this.simpleXdmDefinitionBuilder = void 0;
            this.enabled = true;
            this.registered = false;
            this.dialogProvider = dialogProvider;
            this.simpleXdmDefinitionBuilder = new (0, $2383109b91961b3d$export$b85c05da5be2a57c)(dialogProvider);
        }
    }
    DialogModuleDefinitions.State = State;
})($5d85745bfc132c26$export$b2c1533e87918fe9 || ($5d85745bfc132c26$export$b2c1533e87918fe9 = {}));
class $5d85745bfc132c26$export$d9193a0e0fca7cd8 extends (0, $awwWq.BaseModule) {
    componentWillMount() {
        if (!this.props.dialogProvider) throw new Error('this.props.dialogProvider is not defined');
        this.setState(new $5d85745bfc132c26$export$b2c1533e87918fe9.State(this.props.dialogProvider));
    }
    getModuleRegistrationName() {
        return $5d85745bfc132c26$export$b2c1533e87918fe9.DIALOG_MODULE_NAME;
    }
    getSimpleXdmDefinitionBuilder() {
        return this.state.simpleXdmDefinitionBuilder;
    }
    getProvider() {
        return this.props.dialogProvider;
    }
    render() {
        return null;
    }
    constructor(props){
        super(props);
    }
}
var $5d85745bfc132c26$export$b2c1533e87918fe9;

});

parcelRegister("9MaFN", function(module, exports) {
/* eslint-disable */ // @ts-nocheck

var $awwWq = parcelRequire("awwWq");

/* eslint-disable */ // @ts-nocheck
class $d4483bda8ce28ac0$export$338fba6bed3be020 {
    buildSimpleXdmDefinition() {
        return {
        };
    }
    constructor(dropdownProvider){
        this.dropdownProvider = void 0;
        if (!dropdownProvider) throw new Error('dropdownProvider is not defined');
        this.dropdownProvider = dropdownProvider;
    }
}


(function(DropdownModuleDefinitions) {
    DropdownModuleDefinitions.DROPDOWN_MODULE_NAME = 'dropdown';
    class Props {
        constructor(adaptor, dropdownProvider){
            this.adaptor = void 0;
            this.dropdownProvider = void 0;
            this.adaptor = adaptor;
            this.dropdownProvider = dropdownProvider;
        }
    }
    DropdownModuleDefinitions.Props = Props;
    class State {
        constructor(dropdownProvider){
            this.enabled = void 0;
            this.registered = void 0;
            this.dropdownProvider = void 0;
            this.simpleXdmDefinitionBuilder = void 0;
            this.enabled = true;
            this.registered = false;
            this.dropdownProvider = dropdownProvider;
            this.simpleXdmDefinitionBuilder = new (0, $d4483bda8ce28ac0$export$338fba6bed3be020)(dropdownProvider);
        }
    }
    DropdownModuleDefinitions.State = State;
})($f2ae70c32d5d50e2$export$4279eadb1f181402 || ($f2ae70c32d5d50e2$export$4279eadb1f181402 = {}));
class $f2ae70c32d5d50e2$export$f4d87b4303498ba0 extends (0, $awwWq.BaseModule) {
    componentWillMount() {
        if (!this.props.dropdownProvider) throw new Error('this.props.dropdownProvider is not defined');
        this.setState(new $f2ae70c32d5d50e2$export$4279eadb1f181402.State(this.props.dropdownProvider));
    }
    getModuleRegistrationName() {
        return $f2ae70c32d5d50e2$export$4279eadb1f181402.DROPDOWN_MODULE_NAME;
    }
    getSimpleXdmDefinitionBuilder() {
        return this.state.simpleXdmDefinitionBuilder;
    }
    getProvider() {
        return this.props.dropdownProvider;
    }
    render() {
        return null;
    }
    constructor(props){
        super(props);
    }
}
var $f2ae70c32d5d50e2$export$4279eadb1f181402;

});

parcelRegister("9kO8O", function(module, exports) {
/* eslint-disable */ // @ts-nocheck

var $awwWq = parcelRequire("awwWq");

/* eslint-disable */ // @ts-nocheck
class $6e28cf8732644401$export$f57ca3ba8378bc0b {
    buildSimpleXdmDefinition() {
        return {
        };
    }
    constructor(inlineDialogProvider){
        this.inlineDialogProvider = void 0;
        if (!inlineDialogProvider) throw new Error('inlineDialogProvider is not defined');
        this.inlineDialogProvider = inlineDialogProvider;
    }
}


(function(InlineDialogModuleDefinitions) {
    InlineDialogModuleDefinitions.INLINE_DIALOG_MODULE_NAME = 'inlineDialog';
    class Props {
        constructor(adaptor, inlineDialogProvider){
            this.adaptor = void 0;
            this.inlineDialogProvider = void 0;
            this.adaptor = adaptor;
            this.inlineDialogProvider = inlineDialogProvider;
        }
    }
    InlineDialogModuleDefinitions.Props = Props;
    class State {
        constructor(inlineDialogProvider){
            this.enabled = void 0;
            this.registered = void 0;
            this.inlineDialogProvider = void 0;
            this.simpleXdmDefinitionBuilder = void 0;
            this.enabled = true;
            this.registered = false;
            this.inlineDialogProvider = inlineDialogProvider;
            this.simpleXdmDefinitionBuilder = new (0, $6e28cf8732644401$export$f57ca3ba8378bc0b)(inlineDialogProvider);
        }
    }
    InlineDialogModuleDefinitions.State = State;
})($8e465e19c0053498$export$ae7b722dbdc6e5c7 || ($8e465e19c0053498$export$ae7b722dbdc6e5c7 = {}));
class $8e465e19c0053498$export$b1f44b14f5988e61 extends (0, $awwWq.BaseModule) {
    componentWillMount() {
        if (!this.props.inlineDialogProvider) throw new Error('this.props.inlineDialogProvider is not defined');
        this.setState(new $8e465e19c0053498$export$ae7b722dbdc6e5c7.State(this.props.inlineDialogProvider));
    }
    getModuleRegistrationName() {
        return $8e465e19c0053498$export$ae7b722dbdc6e5c7.INLINE_DIALOG_MODULE_NAME;
    }
    getSimpleXdmDefinitionBuilder() {
        return this.state.simpleXdmDefinitionBuilder;
    }
    getProvider() {
        return this.props.inlineDialogProvider;
    }
    render() {
        return null;
    }
    constructor(props){
        super(props);
    }
}
var $8e465e19c0053498$export$ae7b722dbdc6e5c7;

});

parcelRegister("4G3kC", function(module, exports) {
/* eslint-disable */ // @ts-nocheck

var $awwWq = parcelRequire("awwWq");

/* eslint-disable */ // @ts-nocheck
class $dd1249b258046ef7$export$a2377c7acc103422 {
    buildSimpleXdmDefinition() {
        return {
        };
    }
    constructor(messageProvider){
        this.messageProvider = void 0;
        if (!messageProvider) throw new Error('messageProvider is not defined');
        this.messageProvider = messageProvider;
    }
}


(function(MessageModuleDefinitions) {
    MessageModuleDefinitions.MESSAGE_MODULE_NAME = 'messages';
    class Props {
        constructor(adaptor, messageProvider){
            this.adaptor = void 0;
            this.messageProvider = void 0;
            this.adaptor = adaptor;
            this.messageProvider = messageProvider;
        }
    }
    MessageModuleDefinitions.Props = Props;
    class State {
        constructor(messageProvider){
            this.enabled = void 0;
            this.registered = void 0;
            this.messageProvider = void 0;
            this.simpleXdmDefinitionBuilder = void 0;
            this.enabled = true;
            this.registered = false;
            this.messageProvider = messageProvider;
            this.simpleXdmDefinitionBuilder = new (0, $dd1249b258046ef7$export$a2377c7acc103422)(messageProvider);
        }
    }
    MessageModuleDefinitions.State = State;
})($97f35f107d6f18eb$export$8322ec4fed7b0ec || ($97f35f107d6f18eb$export$8322ec4fed7b0ec = {}));
class $97f35f107d6f18eb$export$22578b4f731c13ad extends (0, $awwWq.BaseModule) {
    componentWillMount() {
        if (!this.props.messageProvider) throw new Error('this.props.messageProvider is not defined');
        this.setState(new $97f35f107d6f18eb$export$8322ec4fed7b0ec.State(this.props.messageProvider));
    }
    getModuleRegistrationName() {
        return $97f35f107d6f18eb$export$8322ec4fed7b0ec.MESSAGE_MODULE_NAME;
    }
    getSimpleXdmDefinitionBuilder() {
        return this.state.simpleXdmDefinitionBuilder;
    }
    getProvider() {
        return this.props.messageProvider;
    }
    render() {
        return null;
    }
    constructor(props){
        super(props);
    }
}
var $97f35f107d6f18eb$export$8322ec4fed7b0ec;
module.exports["MessageModule"] = $97f35f107d6f18eb$export$22578b4f731c13ad;

});

parcelRegister("4AyEX", function(module, exports) {
/* eslint-disable */ // @ts-nocheck
/* eslint-disable */ // @ts-nocheck
class $6352aed04aeb554e$var$DefaultLoggerAPI {
    debug(message, ...optionalParams) {
        console.debug.apply(console, arguments);
    }
    info(message, ...optionalParams) {
        console.info.apply(console, arguments);
    }
    warn(message, ...optionalParams) {
        console.warn.apply(console, arguments);
    }
    error(message, ...optionalParams) {
        console.error.apply(console, arguments);
    }
}
var $6352aed04aeb554e$export$2e2bcd8739ae039 = new $6352aed04aeb554e$var$DefaultLoggerAPI();


class $bfc777fe382729a7$var$LoggerController {
    isDebugEnabled() {
        return this.debugEnabled;
    }
    isInfoEnabled() {
        return this.infoEnabled;
    }
    constructor(){
        this.debugEnabled = false;
        this.infoEnabled = true;
    }
}
/**
 * This class serves two purposes:
 *   - It provides the ability for products to register their implementations
 *     of LoggerAPI for use by the connect front end code.
 *   - It provides the LoggerAPI implementation that connect front end code
 *     should use. This implementation delegates to the registered LoggerAPI
 *     implementation. This class should be used within the connect front end
 *     code as follows:
 *
 *     import logger from '../adaptors/logger/LoggerAdaptor';
 *
 *     logger.info('My message', extraStuffOfInterest, etc, ...);
 */ class $bfc777fe382729a7$var$LoggerAdaptor {
    /**
   * Implementation of AnalyticsRegistry#registerAnalyticsAPI().
   */ registerLoggerAPI(loggerAPI) {
        this.loggerAPI = loggerAPI;
    }
    /**
   * Implementation of LoggerAPI#debug() for use by connect-module-core code.
   */ debug(message, ...optionalParams) {
        try {
            if (this.loggerController.isDebugEnabled()) this.loggerAPI.debug.apply(this.loggerAPI, arguments);
        } catch (exception) {
        // Ignore
        }
    }
    /**
   * Implementation of LoggerAPI#info() for use by connect-module-core code.
   */ info(message, ...optionalParams) {
        try {
            if (this.loggerController.isInfoEnabled()) this.loggerAPI.info.apply(this.loggerAPI, arguments);
        } catch (exception) {
        // Ignore
        }
    }
    /**
   * Implementation of LoggerAPI#warn() for use by connect-module-core code.
   */ warn(message, ...optionalParams) {
        try {
            this.loggerAPI.warn.apply(this.loggerAPI, arguments);
        } catch (exception) {
            const logger = console.warn || console.log;
            if (logger) logger.apply(logger, arguments);
        }
    }
    /**
   * Implementation of LoggerAPI#error() for use by connect-module-core code.
   */ error(message, ...optionalParams) {
        try {
            this.loggerAPI.error.apply(this.loggerAPI, arguments);
        } catch (exception) {
            const logger = console.error || console.log;
            if (logger) logger.apply(logger, arguments);
        }
    }
    constructor(){
        this.loggerController = void 0;
        this.loggerAPI = (0, $6352aed04aeb554e$export$2e2bcd8739ae039);
        this.loggerController = new $bfc777fe382729a7$var$LoggerController();
        window._loggerController = this.loggerController;
    }
}
const $bfc777fe382729a7$export$af88d00dbe7f521 = new $bfc777fe382729a7$var$LoggerAdaptor();
module.exports["logger"] = $bfc777fe382729a7$export$af88d00dbe7f521;

});

parcelRegister("awwWq", function(module, exports) {
/* eslint-disable */ // @ts-nocheck

var $42omo = parcelRequire("42omo");


var $4AyEX = parcelRequire("4AyEX");

(function(ModuleDefinitions) {
    ModuleDefinitions.MIN_REGISTRATION_NAME_LENGTH = 1;
    ModuleDefinitions.MAX_REGISTRATION_NAME_LENGTH = 50;
})($3bb3bde34218ccf6$export$ff885fcfc37de939 || ($3bb3bde34218ccf6$export$ff885fcfc37de939 = {}));
class $3bb3bde34218ccf6$export$adea4f5921a64958 extends $42omo.Component {
    componentDidMount() {
        const props = this.props;
        const registrationName = this.getModuleRegistrationName();
        (0, $4AyEX.logger).debug('Mounting module', registrationName, '...');
        this.validateRegistrationName(registrationName);
        props.adaptor.registerModule(this, props);
        const moduleState = this.state;
        moduleState.enabled = true;
        moduleState.registered = true;
        this.setState(moduleState);
    }
    setEnabled(enabled) {
        const moduleState = this.state;
        moduleState.enabled = enabled;
        this.setState(moduleState);
    }
    isEnabled() {
        return this.state.enabled;
    }
    componentWillUnmount() {
    // Do nothing - we don't unregister modules.
    }
    shouldComponentUpdate() {
        // This module hierarchy never renders anything.
        return false;
    }
    validateRegistrationName(registrationName) {
        if (!registrationName || registrationName.length < $3bb3bde34218ccf6$export$ff885fcfc37de939.MIN_REGISTRATION_NAME_LENGTH) throw new Error('The registration name is too short (< ' + $3bb3bde34218ccf6$export$ff885fcfc37de939.MIN_REGISTRATION_NAME_LENGTH + ' characters).');
        if (registrationName.length > $3bb3bde34218ccf6$export$ff885fcfc37de939.MAX_REGISTRATION_NAME_LENGTH) throw new Error('The registration name is too long (> ' + $3bb3bde34218ccf6$export$ff885fcfc37de939.MAX_REGISTRATION_NAME_LENGTH + ' characters).');
        if (!registrationName.match(/^[a-z]+$/i)) throw new Error('The registration name must only contain alphabetic characters.');
    }
    render() {
        return null;
    }
    constructor(props){
        super(props);
    }
}
var $3bb3bde34218ccf6$export$ff885fcfc37de939;
module.exports["BaseModule"] = $3bb3bde34218ccf6$export$adea4f5921a64958;

});

parcelRegister("e2rLA", function(module, exports) {
/* eslint-disable */ // @ts-nocheck

var $jEqev = parcelRequire("jEqev");

class $c36fa7afd83d5247$export$728f00fa4551317c {
    static validate(dialogProvider) {
        (0, $jEqev.default).checkFunctionExists('dialogProvider', dialogProvider, 'create');
        (0, $jEqev.default).checkFunctionExists('dialogProvider', dialogProvider, 'close');
        (0, $jEqev.default).checkFunctionExists('dialogProvider', dialogProvider, 'setButtonDisabled');
        (0, $jEqev.default).checkFunctionExists('dialogProvider', dialogProvider, 'isButtonDisabled');
        (0, $jEqev.default).checkFunctionExists('dialogProvider', dialogProvider, 'toggleButton');
        (0, $jEqev.default).checkFunctionExists('dialogProvider', dialogProvider, 'setButtonHidden');
        (0, $jEqev.default).checkFunctionExists('dialogProvider', dialogProvider, 'isButtonHidden');
        (0, $jEqev.default).checkFunctionExists('dialogProvider', dialogProvider, 'isActiveDialog');
        let actionClicked = false;
        const myAction = {
            identifier: 'my-action',
            text: 'Some Action',
            onClick: ()=>{
                actionClicked = true;
            }
        };
        const dialogCreationOptions = {
            key: 'my-dialog',
            size: 'medium',
            width: '100%',
            height: '50px',
            chrome: false,
            header: 'My header',
            actions: [
                myAction
            ],
            closeOnEscape: true,
            hint: 'this is a test'
        };
        const bogus_addon_key = 'bogus_app';
        const addon_key = 'foo-app';
        const dialogExtension = {
            addon_key: addon_key,
            key: 'foo-key',
            options: {}
        };
        const dialog = dialogProvider.create(dialogCreationOptions, dialogExtension);
        // Allow contenet resolver promises to complete
        setTimeout(()=>{
            // TODO: Fix under ACJS-735
            // ValidationUtil.checkExists('dialog', dialog);
            // ValidationUtil.checkFunctionExists('dialog', dialog, 'on');
            // Check the dialog is active...
            const isActiveAfterCreation = dialogProvider.isActiveDialog(addon_key);
            if (!isActiveAfterCreation) throw new Error('The dialog should be active');
            // Check the active status returns false for another add-on...
            const isAnotherAppsDialogActive = dialogProvider.isActiveDialog(bogus_addon_key);
            if (isAnotherAppsDialogActive) throw new Error('The dialog should not be active');
            // Check the enabled state of a button...
            if (dialogProvider.isButtonDisabled('my-action')) throw new Error('Button should be enabled by default');
            // Disable a button...
            dialogProvider.setButtonDisabled('my-action', true);
            if (!dialogProvider.isButtonDisabled('my-action')) throw new Error('Button should have been disabled.');
            // Re-enabled a button...
            dialogProvider.toggleButton('my-action');
            if (dialogProvider.isButtonDisabled('my-action')) throw new Error('Button should have been re-enabled.');
            // Check the visibility of a button...
            if (dialogProvider.isButtonHidden('my-action')) throw new Error('Button should be visible by default');
            // Hide a button...
            dialogProvider.setButtonHidden('my-action', true);
            if (!dialogProvider.isButtonHidden('my-action')) throw new Error('Button should have been hidden.');
            dialogProvider.close();
        }, 0);
    }
}

});

parcelRegister("i2nif", function(module, exports) {
/* eslint-disable */ // @ts-nocheck
/* eslint-disable */ // @ts-nocheck
class $ec6a553fcb3206e4$export$137131383bc80874 {
    constructor(){
        /**
     * The key/identifier of this action.
     */ this.actionKey = void 0;
        /**
     * This is the short textual description of the action.
     */ this.actionText = void 0;
        /**
     * This is the function that is called to execute the action.
     */ this.executeAction = void 0;
    }
}
class $ec6a553fcb3206e4$export$b7026fd91c62192e {
    constructor(){
        /**
     * This is an identifier for the flag.
     */ this.id = void 0;
        /**
     * The title text of the flag.
     */ this.title = void 0;
        /**
     * The body text of the flag.
     */ this.body = void 0;
        /**
     * Sets the type of the message. Valid options are "info", "success", "warning" and "error".
     */ this.type = void 0;
        /**
     * The closing behaviour that this flag has. Valid options are "manual", "auto" and "never".
     */ this.close = void 0;
        /**
     * The onClose function must be called whe a user closes the flag.
     */ this.onClose = void 0;
        /**
     * The actions to add to the flag.
     */ this.actions = void 0;
    }
}



var $jEqev = parcelRequire("jEqev");

class $12da298c6ca2281b$export$a28584b2365c8dd4 {
    static validate(flagProvider) {
        (0, $jEqev.default).checkFunctionExists('flagProvider', flagProvider, 'create');
        (0, $jEqev.default).checkFunctionExists('flagProvider', flagProvider, 'isFlagOpen');
        $12da298c6ca2281b$export$a28584b2365c8dd4.validateFlagCreationAndDeletions(flagProvider, 'manual');
        $12da298c6ca2281b$export$a28584b2365c8dd4.validateFlagCreationAndDeletions(flagProvider, 'auto');
        $12da298c6ca2281b$export$a28584b2365c8dd4.validateFlagCreationAndDeletions(flagProvider, 'never');
    }
    static validateFlagCreationAndDeletions(flagProvider, closeFlagOption) {
        const flagActions = [];
        $12da298c6ca2281b$export$a28584b2365c8dd4.validateFlagCreationAndDeletion(flagProvider, closeFlagOption, flagActions, false);
        const flagAction = new (0, $ec6a553fcb3206e4$export$137131383bc80874)();
        flagAction.actionKey = 'some-action';
        flagAction.actionText = 'Some Action';
        flagAction.executeAction = ()=>{
            console.log('Action clicked');
        };
        flagActions.push(flagAction);
        $12da298c6ca2281b$export$a28584b2365c8dd4.validateFlagCreationAndDeletion(flagProvider, closeFlagOption, flagActions, false);
        const flagActionMissingExecuteAction = new (0, $ec6a553fcb3206e4$export$137131383bc80874)();
        flagActionMissingExecuteAction.actionKey = 'some-action';
        flagActionMissingExecuteAction.actionText = 'Some Action';
        flagActions[0] = flagActionMissingExecuteAction;
        $12da298c6ca2281b$export$a28584b2365c8dd4.validateFlagCreationAndDeletion(flagProvider, closeFlagOption, flagActions, true);
    }
    static validateFlagCreationAndDeletion(flagProvider, closeFlagOption, flagActions, expectValidationError) {
        const flagIdsToFlags = new Map();
        const flagId = 'flag-' + new Date().getMilliseconds();
        const flagOptions = {
            id: flagId,
            title: 'My Flag',
            body: 'My flag content',
            type: 'success',
            close: closeFlagOption,
            onClose: (flagId)=>{
                flagIdsToFlags.delete(flagId);
            },
            actions: flagActions
        };
        try {
            const flag = flagProvider.create(flagOptions);
            if (expectValidationError) throw new Error('Expected a validation error, but did not get one.');
            flagIdsToFlags.set(flag.id, flag);
            (0, $jEqev.default).checkExists('flag', flag);
            (0, $jEqev.default).checkFunctionExists('flag', flag, 'close');
            if (closeFlagOption !== 'auto') {
                const flagOpen = flagProvider.isFlagOpen(flag.id);
                if (!flagOpen) throw new Error(`Expected flag to exist.`);
            }
            flag.close();
            if (flagIdsToFlags.size) throw new Error('It looks like the provider did not synchronously call back the onClose method.');
        } catch (exception) {
            if (expectValidationError) ;
            else throw new Error('Did not expect a validation error, but got one.');
        }
    }
}

});

parcelRegister("k9hyL", function(module, exports) {
/* eslint-disable */ // @ts-nocheck

var $jEqev = parcelRequire("jEqev");

/* eslint-disable */ // @ts-nocheck
class $daae3bfbe734e809$export$2d6b340a940d682f {
    resize(width, height) {
        throw new Error('Not implemented yet');
    }
    sizeToParent() {
        throw new Error('Not implemented yet');
    }
    /**
   * This method hides the inline dialog that the add-on identified by this context is
   * being displayed in.
   */ hideInlineDialog() {
        this.inlineDialogOpen = false;
    }
    isInlineDialogOpen() {
        return this.inlineDialogOpen;
    }
    constructor(){
        this.inlineDialogOpen = true;
    }
}
class $daae3bfbe734e809$export$f4e04f09a1f31b14 {
    constructor(appKey, id, key, options){
        this.addon_key = void 0;
        this.id = void 0;
        this.key = void 0;
        this.options = void 0;
        this.addon_key = appKey;
        this.id = id;
        this.key = key;
        this.options = options;
    }
}
class $daae3bfbe734e809$export$13e597eb521ea346 {
    constructor(autoresize, widthinpx, hostFrameOffset, _contextualOperations){
        this.autoresize = void 0;
        this.widthinpx = void 0;
        this.hostFrameOffset = void 0;
        this._contextualOperations = void 0;
        this.title = void 0;
        this.autoresize = autoresize;
        this.widthinpx = widthinpx;
        this.hostFrameOffset = hostFrameOffset;
        this._contextualOperations = _contextualOperations;
    }
}
class $daae3bfbe734e809$export$c2ea901ef0c0e837 {
    static buildNewInstance() {
        const contextualOperations = new $daae3bfbe734e809$export$2d6b340a940d682f();
        const autoresize = true;
        const widthinpx = true;
        const hostFrameOffset = 1;
        const appOptions = new $daae3bfbe734e809$export$13e597eb521ea346(autoresize, widthinpx, hostFrameOffset, contextualOperations);
        const randomId = new Date().getMilliseconds();
        const appKey = 'foo';
        const key = 'bar';
        const id = appKey + '__' + key + '__' + randomId;
        const appInstance = new $daae3bfbe734e809$export$f4e04f09a1f31b14(appKey, id, key, appOptions);
        const appContext = new $daae3bfbe734e809$export$c2ea901ef0c0e837(appInstance);
        return appContext;
    }
    constructor(extension){
        this.extension = void 0;
        this.extension = extension;
    }
}


class $18dd2da8eeae3656$export$c73136b548ed0f6f {
    static validate(inlineDialogProvider) {
        (0, $jEqev.default).checkFunctionExists('inlineDialogProvider', inlineDialogProvider, 'hide');
        const appContext = (0, $daae3bfbe734e809$export$c2ea901ef0c0e837).buildNewInstance();
        inlineDialogProvider.hide(appContext);
    }
}

});

parcelRegister("iViFj", function(module, exports) {
/* eslint-disable */ // @ts-nocheck

var $jEqev = parcelRequire("jEqev");

class $1c11cf1c46a03469$export$4aff556677cdd09a {
    static validate(messageProvider) {
        (0, $jEqev.default).checkFunctionExists('messageProvider', messageProvider, 'clear');
        (0, $jEqev.default).checkFunctionExists('messageProvider', messageProvider, 'onClose');
        const creationRoutineNames = [
            'generic',
            'hint',
            'info',
            'success',
            'warning',
            'error'
        ];
        creationRoutineNames.forEach((creationRoutineName)=>{
            (0, $jEqev.default).checkFunctionExists('messageProvider', messageProvider, creationRoutineName);
            const messageId = 'message-' + new Date().getMilliseconds();
            const title = 'My Message';
            const body = 'My message content';
            const messageOptions = {
                id: messageId,
                closeable: true,
                fadeout: true,
                delay: 2000,
                duration: 4000
            };
            if (creationRoutineName === 'generic') messageProvider.generic(title, body, messageOptions);
            else if (creationRoutineName === 'hint') messageProvider.hint(title, body, messageOptions);
            else if (creationRoutineName === 'info') messageProvider.info(title, body, messageOptions);
            else if (creationRoutineName === 'success') messageProvider.success(title, body, messageOptions);
            else if (creationRoutineName === 'warning') messageProvider.warning(title, body, messageOptions);
            else if (creationRoutineName === 'error') messageProvider.error(title, body, messageOptions);
            (0, $jEqev.default).checkExists('messageId', messageId);
            let dummyOnCloseCalled = false;
            let onCloseCalled = false;
            messageProvider.onClose(messageId, function() {
                onCloseCalled = true;
            });
            messageProvider.onClose('dummy-message-id', function() {
                dummyOnCloseCalled = true;
            });
            messageProvider.clear(messageId);
            if (!onCloseCalled) throw new Error('Expected onClose callback to be called after calling clear.');
            if (dummyOnCloseCalled) throw new Error('Did not expect the dummy onClose callback to be called.');
        });
    }
}

});

parcelRegister("jEqev", function(module, exports) {
/* eslint-disable */ // @ts-nocheck
class $dab87be82a1e9999$export$fa29912b5fdf77b5 {
    static checkExists(objectName, object) {
        if (!object) throw new Error(`${objectName} does not exist.`);
    }
    static checkPropertyExists(objectName, object, propertyName) {
        const objectProperty = object[propertyName];
        if (!objectProperty) throw new Error(`Expected ${objectName} to have a property: ${propertyName}.`);
        if ($dab87be82a1e9999$export$fa29912b5fdf77b5.isFunction(objectProperty)) throw new Error(`${objectName} has a property ${propertyName}, but it is a function.`);
    }
    static checkFunctionExists(objectName, object, functionName) {
        const objectProperty = object[functionName];
        if (!objectProperty) throw new Error(`Expected ${objectName} to have a function: ${functionName}.`);
        if (!$dab87be82a1e9999$export$fa29912b5fdf77b5.isFunction(objectProperty)) {
            const objectPropertyTypeInfo = typeof objectProperty + ' (value: ' + objectProperty + ')';
            throw new Error(`${objectName} has a property ${functionName}, but it is a ${objectPropertyTypeInfo} rather than a function.`);
        }
    }
    static isFunction(object) {
        return typeof object === 'function';
    }
}
var $dab87be82a1e9999$export$2e2bcd8739ae039 = $dab87be82a1e9999$export$fa29912b5fdf77b5;
module.exports["default"] = $dab87be82a1e9999$export$2e2bcd8739ae039;

});

parcelRegister("g7tdI", function(module, exports) {
/*global jest*/ /* eslint-disable */ // @ts-nocheck
/* eslint-disable */ // @ts-nocheck
/* eslint-disable */ // @ts-nocheck
class $9964909a718961e0$export$72c538805177fc9d {
    constructor(){
        this.id = 'mock-iframe-id';
        this.src = 'mock-iframe-src';
        this.name = 'mock-iframe-name';
    }
}


class $3985c97c1da4e1df$export$1cddb33ac1c7fcc0 {
    constructor(){
        this.iframeAttributes = new (0, $9964909a718961e0$export$72c538805177fc9d)();
        this.extension = {};
    }
}


class $e8084417b7bff243$export$d34d7bcfe7ba9cee {
    constructor(){
        this.onIframeEstablished = jest.fn();
        this.offIframeEstablished = jest.fn();
        this.onIframeUnload = jest.fn();
        this.offIframeUnload = jest.fn();
        this.createExtension = jest.fn((params)=>{
            let val = new (0, $3985c97c1da4e1df$export$1cddb33ac1c7fcc0)();
            val.iframeAttributes.src = params.url;
            return val;
        });
        this.destroy = jest.fn();
        this.getContentResolver = jest.fn();
        this.hasJwt = jest.fn();
        this.isJwtExpired = jest.fn();
    }
}

});

parcelRegister("8tdEV", function(module, exports) {
$parcel$export(module.exports, "AnalyticsCategories", () => $9b7e9f17bb4a6f67$export$99cb2c76c1f7b090);
$parcel$export(module.exports, "AnalyticsActions", () => $9b7e9f17bb4a6f67$export$9dbfb0e4698d080f);
/* eslint-disable */ // @ts-nocheck
(function(AnalyticsCategories) {
    AnalyticsCategories.dialog = 'dialog';
    AnalyticsCategories.iframe = 'iframe';
    AnalyticsCategories.inlineDialog = 'inlineDialog';
})($9b7e9f17bb4a6f67$export$99cb2c76c1f7b090 || ($9b7e9f17bb4a6f67$export$99cb2c76c1f7b090 = {}));
(function(AnalyticsActions) {
    AnalyticsActions.create = 'create';
    AnalyticsActions.close = 'close';
    AnalyticsActions.error = 'error';
    AnalyticsActions.timeout = 'timeout';
    AnalyticsActions.established = 'established';
})($9b7e9f17bb4a6f67$export$9dbfb0e4698d080f || ($9b7e9f17bb4a6f67$export$9dbfb0e4698d080f = {}));
const $9b7e9f17bb4a6f67$export$cb67e4122f7d424a = [
    $9b7e9f17bb4a6f67$export$9dbfb0e4698d080f.create,
    $9b7e9f17bb4a6f67$export$9dbfb0e4698d080f.close,
    $9b7e9f17bb4a6f67$export$9dbfb0e4698d080f.error,
    $9b7e9f17bb4a6f67$export$9dbfb0e4698d080f.timeout,
    $9b7e9f17bb4a6f67$export$9dbfb0e4698d080f.established
];
var $9b7e9f17bb4a6f67$export$99cb2c76c1f7b090, $9b7e9f17bb4a6f67$export$9dbfb0e4698d080f;
module.exports["allowedStrings"] = $9b7e9f17bb4a6f67$export$cb67e4122f7d424a;

});


//# sourceMappingURL=ConnectAddon.659a3f7a.js.map
